import { render, staticRenderFns } from "./leftTree.vue?vue&type=template&id=13107487&scoped=true"
import script from "./leftTree.vue?vue&type=script&lang=js"
export * from "./leftTree.vue?vue&type=script&lang=js"
import style0 from "./leftTree.vue?vue&type=style&index=0&id=13107487&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13107487",
  null
  
)

export default component.exports